(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/promos/no-open-draws.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/promos/no-open-draws.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.no_open_draws = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"promos-no-open-draws\">"
    + ((stack1 = ((helper = (helper = helpers.noOpenDrawsText || (depth0 != null ? depth0.noOpenDrawsText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"noOpenDrawsText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>";
},"useData":true});
Handlebars.partials['components-app-product_start_page-no_open_draws'] = svs.app.product_start_page.templates.no_open_draws;
})(svs, Handlebars);

 })(window);